export const stateName = 'featureSwitches' as const
